import './AttendantsManagement.scss';
import { QueueManagementConstants } from './../../QueueManagementConstants';
import { QueuesTracks } from '../../QueueManagementConstants';
import { debounce } from 'data/function';
import AddAttendantModalView from './AddAttendantsModal/AddAttendantModalView.html';
import { AddAttendantModalController } from './AddAttendantsModal/AddAttendantModalController';
import { AttendanceFeatures } from '../../../AttendanceFeatures';
export class AttendantsContainerController {
    static $inject = ['$scope', 'DeskConfigurationService', 'LoadingService', 'SegmentService', 'TeamService', 'ModalService', '$translate', 'PermissionsService', 'AlertService', 'BlipToastService', 'TenantService'];
    constructor($scope, DeskConfigurationService, LoadingService, SegmentService, TeamService, ModalService, $translate, PermissionsService, AlertService, BlipToastService, TenantService) {
        'ngInject';
        this.$scope = $scope;
        this.DeskConfigurationService = DeskConfigurationService;
        this.LoadingService = LoadingService;
        this.SegmentService = SegmentService;
        this.TeamService = TeamService;
        this.ModalService = ModalService;
        this.$translate = $translate;
        this.PermissionsService = PermissionsService;
        this.AlertService = AlertService;
        this.BlipToastService = BlipToastService;
        this.TenantService = TenantService;
        this.attendants = [];
        this.filteredAttendants = [];
        this.attendantsCount = 0;
        this.filteredAttendantsCount = 0;
        this.inputTextSearchAttendants = '';
        this.isManagerView = true;
        this.isQueueManagementView = true;
        this.currentState = QueueManagementConstants.STATES.VIEWING;
        this.isViewing = QueueManagementConstants.STATES.VIEWING;
        this.isAdding = QueueManagementConstants.STATES.ADDING;
        this.isEdit = QueueManagementConstants.STATES.EDITING;
        this.take = 10;
        this.skip = 0;
        this.searchAttendant = async (event) => {
            this.inputTextSearchAttendants = event.detail.value;
            if (this.inputTextSearchAttendants) {
                this.filterAttendants();
            }
            else {
                this.filteredAttendants = this.attendants.slice();
                this.filteredAttendantsCount = this.attendantsCount;
                this.checkLoadMoreStatus();
            }
            this.setIsLoading(false);
            this.SegmentService.createBotTrack(QueuesTracks.QUEUE_ATTENDANTS_SEARCHED, this.application, this.trackPayload);
            this.isAnyAttendantSelected = this.filteredAttendants.some(c => c.checkSelected == true);
        };
        this.onCheckAll = (selected) => {
            this.filteredAttendants = this.filteredAttendants.map((attendant) => ({
                ...attendant,
                checkSelected: selected,
            }));
        };
    }
    async $onInit() {
        this.setIsLoading(false);
        this.inputTextSearchAttendants = '';
        this.debouncedSearch = debounce(this.searchAttendant, 500);
        if (this.queue) {
            this.getAttendants();
        }
        this.trackPayload = { source: QueuesTracks.SOURCE.PORTAL };
        this.SegmentService.createBotTrack(QueuesTracks.PAGE_ATTENDANT_OPENED, this.application, this.trackPayload);
        this.isBillablePlanContract = await this.TenantService.checkIfBillableContract();
        this.isAnyAttendantSelected = false;
        this.canEditQueue = await this.PermissionsService.hasPermissions(QueueManagementConstants.WRITE, QueueManagementConstants.DESK);
        this.isAssignAttendantInQueue = await AttendanceFeatures.isAssignAttendantInQueue();
    }
    async filterAttendants() {
        this.filteredAttendants = [];
        this.filteredAttendantsCount = 0;
        try {
            let attendants;
            const { items, total } = await this.TeamService.filterAttendantsQueue(this.queue.name, this.inputTextSearchAttendants, this.filteredAttendants.length, this.take);
            attendants = this.mapAttendants(items);
            this.filteredAttendants.push(...attendants);
            this.filteredAttendantsCount = total;
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.checkLoadMoreStatus();
        }
        this.isAnyAttendantSelected = this.filteredAttendants.some(c => c.checkSelected == true);
    }
    mapAttendants(items) {
        return items ? items.map((item) => {
            this.setAttendantValues(item, item.teams, item.agentSlots);
            return item;
        }) : [];
    }
    checkLoadMoreStatus() {
        if (this.isFilterMode()) {
            this.canLoadMore = this.filteredAttendants.length < this.filteredAttendantsCount;
        }
        else {
            this.canLoadMore = this.attendants.length < this.attendantsCount;
        }
    }
    isFilterMode() {
        if (this.inputTextSearchAttendants == undefined || this.inputTextSearchAttendants === '') {
            return false;
        }
        return true;
    }
    async clearSearchAndTrack() {
        await this.clearSearch();
        this.SegmentService.createBotTrack(QueuesTracks.ATTENDANT_CLEAR_SEARCH, this.application, this.trackPayload);
    }
    async clearSearch() {
        this.inputTextSearchAttendants = '';
        this.currentState = QueueManagementConstants.STATES.VIEWING;
        this.filteredAttendants = this.attendants.slice();
        this.filteredAttendantsCount = this.attendantsCount;
        this.checkLoadMoreStatus();
    }
    setCurrentState(state) {
        this.currentState = state;
    }
    setIsLoading(isLoading) {
        this.isLoading = isLoading;
    }
    async getAttendants() {
        if (this.isLoading) {
            return;
        }
        try {
            if (!this.queue.id) {
                return;
            }
            this.setIsLoading(true);
            const { items, total } = await this.TeamService.getAttendantsQueue(this.queue.name, this.skip, this.take);
            this.attendants = this.mapAttendants(items);
            this.filteredAttendants = this.attendants.slice();
            this.attendantsCount = total;
            this.filteredAttendantsCount = this.attendantsCount || 0;
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.checkLoadMoreStatus();
            this.setIsLoading(false);
        }
    }
    setAttendantValues(attendant, teams, agentSlots) {
        attendant.email = attendant.email || decodeURIComponent(attendant.identity.split('@')[0]);
        attendant.fullName = attendant.fullName || attendant.email.split('@')[0];
        attendant.teams = teams;
        attendant.editingTeams = teams.map((t) => ({ text: t }));
        attendant.agentSlots = agentSlots;
        attendant.editingAgentSlots = agentSlots;
    }
    async loadMore() {
        if (this.isFilterMode()) {
            let attendants;
            const { items, total } = await this.TeamService.filterAttendantsQueue(this.queue.name, this.inputTextSearchAttendants, this.filteredAttendants.length, this.take);
            attendants = this.mapAttendants(items);
            this.filteredAttendants.push(...attendants);
            this.filteredAttendantsCount = total;
            this.checkLoadMoreStatus();
        }
        else {
            const { items, total } = await this.TeamService.getAttendantsQueue(this.queue.name, this.attendants.length, this.take);
            let attendants;
            attendants = this.mapAttendants(items);
            this.attendants.push(...attendants);
            this.attendantsCount = total;
            this.filteredAttendantsCount = this.attendantsCount;
            this.filteredAttendants = this.attendants.slice();
            this.checkLoadMoreStatus();
        }
        this.isAnyAttendantSelected = this.filteredAttendants.some(c => c.checkSelected == true);
    }
    onCheckAttendant() {
        this.isAnyAttendantSelected = this.filteredAttendants.some(c => c.checkSelected == true);
    }
    async onClickDelete(identity) {
        if (!this.canEditQueue) {
            return;
        }
        this.SegmentService.createBotTrack(QueuesTracks.QUEUE_ATTENDANTS_UNASSIGN, this.application, this.trackPayload);
        await this.openModalDeleteAttendant('queue-management.attendants.unassignAttendantHeader', 'queue-management.attendants.unassignAttendantBody', async () => await this.deleteModel(identity));
    }
    async onClickDeleteSelecteds() {
        if (!this.canEditQueue) {
            return;
        }
        this.SegmentService.createBotTrack(QueuesTracks.QUEUE_ATTENDANTS_UNASSIGN_ALL, this.application, this.trackPayload);
        await this.openModalDeleteAttendant('queue-management.attendants.unassignAttendantAllHeader', 'queue-management.attendants.unassignAttendantAllBody', async () => await this.deleteSelectedModels());
    }
    async openModalDeleteAttendant(header, body, callback) {
        try {
            const modalTitle = await this.$translate(header);
            const modalBody = await this.$translate(body, { name: this.queue.name });
            const confirm = await this.$translate('queue-management.attendants.unassignAttendantConfirm');
            const cancel = await this.$translate('queue-management.attendants.unassignAttendantAbort');
            await this.AlertService.show({
                title: modalTitle,
                body: modalBody,
                variant: 'warning',
                icon: 'warning',
                buttons: {
                    cancel: cancel,
                    confirm: confirm,
                },
                callback: {
                    cancelButtonAction: () => {
                        this.SegmentService.createBotTrack(QueuesTracks.QUEUE_ATTENDANTS_UNASSIGN_CANCEL, this.application, this.trackPayload);
                    },
                    confirmButtonAction: callback,
                },
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    async deleteModel(identity) {
        this.SegmentService.createBotTrack(QueuesTracks.QUEUE_ATTENDANTS_UNASSIGN_CONFIRM, this.application, this.trackPayload);
        this.setIsLoading(true);
        const isSucceess = await this.unsetAttendance(identity);
        if (!isSucceess) {
            this.BlipToastService.show('danger', {
                msg: await this.$translate('queue-management.attendants.unassignAttendantError'),
            });
        }
        this.setIsLoading(false);
        await this.getAttendants();
        this.onChange({ $length: this.attendants.length });
    }
    async deleteSelectedModels() {
        this.SegmentService.createBotTrack(QueuesTracks.QUEUE_ATTENDANTS_UNASSIGN_CONFIRM, this.application, this.trackPayload);
        const attendants = this.filteredAttendants.filter(c => c.checkSelected);
        this.setIsLoading(true);
        const isAllSuccess = await Promise.all(attendants.map(item => this.unsetAttendance(item.identity)));
        if (isAllSuccess.some(p => p === false)) {
            this.BlipToastService.show('danger', {
                msg: await this.$translate('queue-management.attendants.unassignAttendantsError'),
            });
        }
        this.setIsLoading(false);
        await this.getAttendants();
        this.isAnyAttendantSelected = false;
        this.onChange({ $length: this.attendants.length });
    }
    async unsetAttendance(identity) {
        const attendant = this.attendants.find(c => c.identity == identity);
        attendant.teams = attendant.teams.removeItem(this.queue.name);
        try {
            await this.saveAttendant(attendant);
            this.attendants = this.attendants.removeItem(attendant);
            return true;
        }
        catch {
            return false;
        }
    }
    async addAttendant() {
        if (!this.canEditQueue) {
            return;
        }
        this.SegmentService.createBotTrack(QueuesTracks.QUEUE_ATTENDANTS_ASSIGN, this.application, this.trackPayload);
        if (!this.queue.id) {
            await this.BlipToastService.show('danger', {
                msg: await this.$translate('queue-management.errors.newNameBeforeEditAtendant'),
            });
            return;
        }
        const modal = await this.ModalService.showModal({
            template: AddAttendantModalView,
            controller: AddAttendantModalController,
            controllerAs: '$ctrl',
            inputs: {
                application: this.application,
                attendantsIdentity: this.attendants.map(c => c.identity),
            },
        });
        const data = await modal.close;
        if (data && Array.isArray(data)) {
            try {
                this.setIsLoading(true);
                await Promise.all(data.map((item) => {
                    item.teams.push(this.queue.name);
                    this.setAttendantValues(item, item.teams, item.agentSlots);
                    return this.saveAttendant(item).then(() => this.attendants.push(item));
                }));
                this.attendantsCount = this.attendantsCount || 0;
                this.attendantsCount += data.length;
                this.clearSearch();
                this.setIsLoading(false);
                this.onChange({ $length: this.attendants.length });
                this.BlipToastService.show('success', {
                    msg: await this.$translate('queue-management.attendants.assignAttendantSuccess'),
                });
            }
            catch (e) {
                this.BlipToastService.show('danger', {
                    msg: await this.$translate('queue-management.attendants.assignAttendantError'),
                });
                console.error(e);
            }
            finally {
                this.checkLoadMoreStatus();
                this.setIsLoading(false);
            }
        }
    }
    async saveAttendant(attendant) {
        await this.TeamService.set([attendant]);
    }
}
AttendantsContainerController.$inject = ['$scope', 'DeskConfigurationService', 'LoadingService', 'SegmentService', 'TeamService', 'ModalService', '$translate', 'PermissionsService', 'AlertService', 'BlipToastService', 'TenantService'];
